import React from 'react';
import styled from 'styled-components';

import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';
import useScreenQuery from '../../../hooks/useScreenQuery';

const LimitChangeConfirmModal = ({ onCancel, onConfirm, isLoading, message = 'add', isVisible }: Props) => {
	const { isSmall } = useScreenQuery();

	if (!isVisible) return null;

	return (
		<Modal onClose={onCancel} title="Confirm Limits">
			{message === 'add' && (
				<ModalText isSmallScreen={isSmall}>
					Please note that this is a firm commitment. You will not be able to cancel or loosen your limits until your
					chosen timeframe has expired.
					<br />
					You may however set more restrictive limits at any time.
				</ModalText>
			)}
			{message === 'remove' && (
				<ModalText isSmallScreen={isSmall}>
					Are you sure you want to remove this limit?
				</ModalText>
			)}
			<Button isLoading={isLoading} kind="white" height={50} onClick={onConfirm}>
				Confirm
			</Button>
			<Button height={50} onClick={onCancel}>
				Cancel
			</Button>
		</Modal>
	);
};

export default LimitChangeConfirmModal;

interface Props {
	onCancel: () => void;
	onConfirm: () => void;
	isLoading?: boolean;
	isVisible: boolean;
	message: 'add' | 'remove';
}

const ModalText = styled.p<{ isSmallScreen: boolean }>`
	text-align: center;
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	line-height: ${({ isSmallScreen }) => (isSmallScreen ? '18px' : '24px')};
`;
